import styled from '@emotion/styled'
import { color, space, SpaceProps } from 'styled-system'

export const DatePickerSelect = styled.select<SpaceProps>`
  ${space};
  height: 36px;
`

export const DatePickerWrapper = styled.div`
  position: relative;
  width: 100%;
  .DateInput {
    display: flex;
    width: 100%;
  }
  .DateInput_input {
    ${color};
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    font-style: normal;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.2s;
    outline: none;
    font-size: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 0.25rem;
    border: 1px solid;
    border-color: inherit;
    background-color: #fff;

    &:disabled {
      opacity: 0.5;
    }
  }
  .DateInput_input__focused {
    background: 'background.surface';
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    color: #fff;
  }
  .SingleDatePicker {
    display: flex;
  }
  .SingleDatePicker_picker {
    z-index: 1700;
  }
  .SingleDatePicker > div,
  .SingleDatePicker > div > .SingleDatePickerInput {
    width: 100%;
  }
  .SingleDatePickerInput {
    align-items: center;
    display: flex;
  }
  .SingleDatePickerInput__withBorder {
    border: none;
    height: 40px;
  }
  .CalendarMonth_caption {
    padding-top: 16px;
  }
  .SingleDatePickerInput_calendarIcon {
    margin: 0;
    position: absolute;
    right: 0;
  }
  .SingleDatePickerInput_clearDate {
    margin: 0 30px 0 0px;
  }
  .DateRangePicker {
    width: 100%;
  }
  .DateRangePickerInput {
    display: flex;
    align-items: center;
    padding: 0;
  }
  .DateRangePickerInput_calendarIcon {
    margin: 0px;
    padding: 5px;
  }
  .DateRangePickerInput_clearDates {
    padding: 0;
  }
  .DateRangePickerInput_clearDates_default:focus,
  .DateRangePickerInput_clearDates_default:hover {
    background: transparent;
  }
`
